import { Direction } from "../../../Models";
import { RootState } from "../../Store";

export const selectDirection = (state: RootState) => state.general.direction;

export const selectIsRtl = (state: RootState) => state.general.direction === Direction.RTL;

export const selectActiveLanguage = (state: RootState) => state.general.activeLanguage;

export const selectUserDetails = (state: RootState) => state.general.userDetails;

export const selectIsUserLoggedIn = (state: RootState) => state.general.userIsLoggedIn;

export const selectIsUserNeedToViewSharableItem = (state: RootState) => state.general.userNeedToViewSharableItem;

export const selectTypeOfSharableItem = (state: RootState) => state.general.typeOfSharableItem;

export const selectSharedItemId = (state: RootState) => state.general.sharedSavedItemId;

export const selectApiErrors = (state: RootState) => state.general.apiErrors;

export const selectUserWantsToBeRemembered = (state: RootState) => state.general.userWantsToBeRemembered;

export const selectAppIsReady = (state: RootState) => state.general.appIsReady;

export const selectUser = (state: RootState) => state.general.userDetails;

export const selectSummaryDescription = (state: RootState) => state.general.summaryDescription;

export const selectErrorFromServer = (state: RootState) => state.general.changeRecipeErrorFromServer;

export const selectAgriIsMainInterestOfUser = (state: RootState) => state.general.userDetails?.role === "OpenFieldAgriculture";

export const selectMetricMethods = (state: RootState) => ({
    metricMethods: state.general.metricMethods,
    activeMetricMethod: state.general.activeMetricMethod || "",
});

export const selectProducts = (state: RootState) => state.general.products;

export const selectCrops = (state: RootState) => state.general.crops;

export const selectIsAgri = (state: RootState) => state.general.isAgri;

export const selectCountriesWithProducts = (state: RootState) => state.general.countriesWithHaifaProducts;

export const selectShowSaveProcessModal = (state: RootState) => state.general.showSaveProcessModal;
export const selectGreenBarState = (state: RootState) => state.general.greenBar;
export const selectCurrentVisibleSavedItemName = (state: RootState) => state.general.currentVisibleSavedItemName;
export const selectCurrentVisibleSavedItemId = (state: RootState) => state.general.currentVisibleSavedItemId;

export const selectShowClearThisStepModal = (state: RootState) => state.general.showClearThisStepModal;

export const selectUserNavigateToMainPage = (state: RootState) => state.general.userIsNavigateToMainPage;
